import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./SunglassesCollectionSection.css";
import { renderTextWithNormalDash } from "../../utils/textFormatters";



const SunglassesCollectionSection = ({ collections, heading }) => {
  return (
    <section className="collections-section py-5">
      <Container>
        <h2 className="section-title mb-5">
          {heading.heading || "Our"} <span>{heading.headingGold || "Collections"}</span>
        </h2>
        <div className="collection-list">
          {collections.map((item, index) => (
            <Row className="align-items-center mb-4 collection-row" key={index}>
              <Col md={7}>
                <div className="collection-image">
                  <img src={item.image} alt={item.title} />
                </div>
              </Col>
              <Col md={5}>
                <div className="collection-content">
                  <h3>{renderTextWithNormalDash(item.title)}</h3>
                  <p>{renderTextWithNormalDash(item.desc)}</p>
                </div>
              </Col>
            </Row>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default SunglassesCollectionSection;
